export default __webpack_public_path__ + "static/media/dr-dayson-dkt.8958abc1.png";